import { Typography, Box, Button, IconButton, useTheme, TableRow, Table, TableContainer, TableBody, TableCell } from '@mui/material'
import { useAssignmentStore } from '../../store/assignment.store'
import { Link, useSearchParams } from 'react-router-dom'
import DataLoadingSpinner from '../common/DataLoadingSpinner'
import noASsignmentImg from '../../assets/noassignment.svg'
import { ASSIGNMENT_CONVERT_DUE_TIME_BEFORE, Icons, formatDate } from '../../utils/utilities'
import CustomSearchBar from '../common/CustomSearchBar'
import ConfirmDialog from '../common/ConfirmDialog'
import React, { useCallback, useEffect, useState } from 'react'
import AssignmentViewer from '../common/AssignmentViewer'
import { observer } from 'mobx-react'
import TableHeader from '../common/TableHeader'
import { useUserStore } from '../../store/user.store'
import CustomTabs from '../common/CustomTabs'
import dayjs from 'dayjs'
import CustomChip from '../common/CustomChip'

const columns = [
    { name: "Assignment Name", minWidth: "200px", align: "left", padding: "5px 10px 5px 10px" },
    { name: "Subject", align: "left", minWidth: "180px" },
    { name: "Due Date", minWidth: "150px", align: "left" },
    { name: "Mode", minWidth: "150px", align: "center" },
    { name: "Submissions", align: "center" },
    { name: "Assignment for", minWidth: "200px", align: "left" },
    { name: "Actions", align: "right", padding: "5px 10px 5px 10px" },
]

const tabs = [
    { label: "All", value: "all", icon: Icons.default.Calendar },
    { label: "Completed", value: "completed", icon: Icons.default.CheckCircleIcon },

]

const AssignmentsList = observer( ( { editAssignment, setView } ) => {

    const AssignmentStore = useAssignmentStore()
    const UserStore = useUserStore()

    // const [open, setOpen] = useState( false )
    const [selectedValue, setSelectedValue] = useState( null )
    const [deleting, setDeleting] = useState( false )
    const [loaded, setLoaded] = useState( false )
    const [confirmDialogStatus, setConfirmDialogStatus] = useState( false )
    const [confirmAction, setConfirmAction] = useState( null )
    const [confirmMessage, setConfirmMessage] = useState( null )

    const [searchParams, setSearchParams] = useSearchParams( { assignmentFilter: 'all', searchText: '', selectedAssignmentId: null, open: false } )
    const searchText = searchParams.get( 'searchText' ) || ""
    const selectedAssignmentId = searchParams.get( 'selectedAssignmentId' ) || null
    const assignmentFilter = searchParams.get( 'assignmentFilter' ) || "completed"
    const open = searchParams.get( 'open' ) || false

    const { palette, table, border, shadows } = useTheme()

    const setSearchParamValue = useCallback( ( key, val ) => {
        setSearchParams( prev => {
            const newSearchParams = new URLSearchParams( prev )
            newSearchParams.set( key, val )
            return newSearchParams
        }, { replace: true } )
    }, [setSearchParams] )

    const handleClickOpen = ( value ) => {
        setSelectedValue( value )
        setSearchParams( prev => {
            const newSearchParams = new URLSearchParams( prev )
            newSearchParams.set( 'open', true )
            newSearchParams.set( 'selectedAssignmentId', value.assignment_id )
            return newSearchParams
        }, { replace: true } )
    }

    const handleClose = ( value ) => {
        setSearchParams( prev => {
            const newSearchParams = new URLSearchParams( prev )
            newSearchParams.set( 'open', false )
            newSearchParams.set( 'selectedAssignmentId', null )
            return newSearchParams
        }, { replace: true } )
        setSelectedValue( null )
    }

    const deleteAssignment = async ( id ) => {
        setDeleting( true )
        let payload = { "assignment_id": id }
        await AssignmentStore.deleteAssignment( payload )
        setDeleting( false )
    }

    const openDeleteDialog = ( id, name ) => {
        setConfirmAction( () => async () => {
            await deleteAssignment( id )
            setConfirmDialogStatus( false )
        } )
        setConfirmMessage(
            <p>
                Assignment <u><b><i>{name}</i></b></u> will be deleted permanently.
            </p>
        )
        setConfirmDialogStatus( true )
    }

    const assignmentFilterFunc = ( item ) => {
        if ( assignmentFilter === "all" ) return item["assignment_name"]?.toLowerCase()?.indexOf( searchText?.toLowerCase() ) > -1 || item["assignment_subject"]["subject_name"]?.toLowerCase()?.indexOf( searchText?.toLowerCase() ) > -1
        if ( assignmentFilter === "due" ) {
            let dueDate = new Date( item.assignment_due_date )
            dueDate = new Date( dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate() + 1 )

            return dueDate > new Date() &&
                ( item["assignment_name"]?.toLowerCase()?.indexOf( searchText?.toLowerCase() ) > -1 || item["assignment_subject"]["subject_name"]?.toLowerCase()?.indexOf( searchText?.toLowerCase() ) > -1 )

        }
        if ( assignmentFilter === "completed" ) {
            let dueDate = new Date( item.assignment_due_date )
            dueDate = new Date( dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate() + 1 )

            return ( item.submission_exists > 0 || dueDate < new Date() )
                && ( item["assignment_name"]?.toLowerCase()?.indexOf( searchText?.toLowerCase() ) > -1 || item["assignment_subject"]["subject_name"]?.toLowerCase()?.indexOf( searchText?.toLowerCase() ) > -1 )
        }
        return true
    }

    const getAssignments = useCallback( async () => {
        if ( AssignmentStore.getErrors.assignments )
            await AssignmentStore.fetchAssignmentByAuthor()
        if ( "" + selectedAssignmentId !== 'null' || selectedAssignmentId ) {
            setSelectedValue( AssignmentStore.getAssignment.find( assignment => +assignment.assignment_id === +selectedAssignmentId ) )
            setSearchParams( prev => {
                const newVals = new URLSearchParams( prev )
                newVals.set( 'open', true )
                return newVals
            }, { replace: true } )
        } else {
            setSearchParams( prev => {
                const newVals = new URLSearchParams( prev )
                newVals.set( 'open', false )
                return newVals
            }, { replace: true } )
        }
        if ( UserStore.getErrorsStatuses?.academicYearsAndBatches === true )
            await UserStore.fetchUsersAllBatchesAndSectionList()
        setLoaded( true )
    }, [setSearchParams, AssignmentStore, UserStore, selectedAssignmentId] )

    useEffect( () => {
        getAssignments( true )
    }, [getAssignments] )

    return (
        <Box overflow="visible" display="flex" flexDirection="column" >
            {/* Dialogs, Modals, Poppers */}
            {confirmAction && <ConfirmDialog waiting={deleting} status={confirmDialogStatus} confirmAction={confirmAction} cancelAction={() => setConfirmDialogStatus( false )} message={confirmMessage} actionName="Yes, Delete it" />}
            {open === 'true' && <AssignmentViewer loaded={loaded} selectedValue={selectedValue} open={open === 'true' && selectedAssignmentId !== 'null'} onClose={handleClose} />}

            {/* Main Content */}
            <Box >
                <Box display="flex" flexWrap="wrap" gap="20px" justifyContent="space-between" alignItems="center">
                    <Box flexGrow={1}>
                        <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px">Assignments</Typography>
                        <Typography variant="subtitle2" fontSize="12px" color='textSecondary' >Manage all your assignments here.</Typography>
                    </Box>
                </Box>
            </Box>
            {loaded && AssignmentStore?.getAssignment.length > 0 && <Box marginTop="20px" overflow="visible" display="flex" flexDirection="column" flexGrow={1} className="custom-scrollbar" gap="10px">

                <Box display="flex" flexWrap="wrap" gap="10px"  >
                    <CustomTabs value={assignmentFilter} tabs={tabs} handleTabChange={val => setSearchParamValue( 'assignmentFilter', val )} />
                    <CustomSearchBar style={{ flexGrow: 1 }} onChange={( e ) => setSearchParamValue( 'searchText', e.target.value )} value={searchText} placeholder="Search by subject or title" />
                    <Button sx={{ flexGrow: { xs: "1", sm: "initial" } }} disableElevation startIcon={Icons.default.AddIcon} onClick={() => setView( "create" )} variant='contained'>Create New Assignment</Button>

                </Box>

                {AssignmentStore?.getAssignment.filter( assignmentFilterFunc ).length > 0 && <Box borderRadius="5px" overflow="auto" border={border[1]}>
                    <TableContainer sx={{ overflow: "auto", height: "100%" }} >
                        <Table stickyHeader>
                            <TableHeader columns={columns} />
                            <TableBody>
                                {AssignmentStore?.getAssignment.filter( assignmentFilterFunc ).map( ( assignment, aindex ) => {
                                    let accessGroups = []
                                    for ( const groupId of assignment.assignment_batch_id?.split( "," ) ) {
                                        const access = UserStore.getUsersLegacyAndCurrentBatchesAndSectionList?.find( i => ( +i.batch_assignment_id === +groupId || `${i.section_assignment_id}-${i.section_short_name}` === String( groupId ) ) )
                                        let title = ''
                                        if ( access?.section_assignment_id ) {
                                            title = `${access.course_branch_short_name ? access.course_branch_short_name + "," : ""} ${access?.current_year ? `year: ${access?.current_year},` : ""} ${access.current_sem ? `Sem: ${access.current_sem},` : ""} Sec: ${access.section_short_name}`
                                        } else if ( access?.batch_assignment_id )
                                            title = `${access.course_name_short ? access.course_name_short + "," : ""} ${access?.current_year ? `year: ${access?.current_year},` : ""} ${access.current_sem ? `Sem: ${access.current_sem},` : ""} Batch: ${access.batch_short_name}`
                                        accessGroups.push( title )
                                    }
                                    return (
                                        <TableRow className='table-row' sx={{ ":hover": { background: palette.rowHover, cursor: "pointer" } }} key={assignment.assignment_id}>
                                            <TableCell onClick={() => handleClickOpen( assignment )} sx={{ color: table.color, padding: columns[0].padding || "10px 20px" }}>{assignment.assignment_name}</TableCell>
                                            <TableCell onClick={() => handleClickOpen( assignment )} sx={{ textTransform: "capitalize", color: table.color, padding: columns[1].padding || "10px 20px" }}>{assignment.assignment_subject?.subject_name || "----"}</TableCell>
                                            <TableCell onClick={() => handleClickOpen( assignment )} sx={{ color: table.color, padding: columns[2].padding || "10px 20px" }}>
                                                <Box display="flex" gap="5px" alignItems="center">
                                                    <Box display="flex" alignItems="center" fontSize="18px" component="span">{Icons.default.Calendar}</Box>
                                                    <Typography component="span" fontSize="inherit">{
                                                        dayjs( assignment.assignment_created_at ) < dayjs( ASSIGNMENT_CONVERT_DUE_TIME_BEFORE ) ?
                                                            `${dayjs( assignment.assignment_due_date ).format( "DD MMM YYYY" )}, 11:59 PM` :
                                                            dayjs( assignment.assignment_due_date ).format( "DD MMM YYYY, hh:mm A" )
                                                    }
                                                    </Typography>
                                                </Box>
                                            </TableCell>
                                            <TableCell onClick={() => handleClickOpen( assignment )} sx={{ color: table.color, padding: columns[3].padding || "10px 20px" }} align="center">
                                                <CustomChip
                                                    tooltipTitle={assignment.assignment_submission_mode === 'offline' ? "Submitted through yellow books" : "Submitted through Alive platform"}
                                                    startIcon={assignment.assignment_submission_mode === 'offline' ? Icons.default.Class : Icons.default.SystemTheme}
                                                    value={assignment.assignment_submission_mode || 'online'}
                                                />
                                            </TableCell>
                                            <TableCell onClick={() => handleClickOpen( assignment )} sx={{ color: table.color, padding: columns[3].padding || "10px 20px" }} align="center">{assignment.assignment_submission || 0}</TableCell>
                                            <TableCell onClick={() => handleClickOpen( assignment )} sx={{ color: table.color, padding: columns[4].padding || "10px 20px" }}>
                                                <Box display="flex" flexDirection="column" gap="5px" >
                                                    {accessGroups?.map( g => ( <em key={g}>{g}</em> ) )}
                                                </Box>
                                            </TableCell>
                                            <TableCell align="right" sx={{ color: table.color, padding: columns[5].padding || "10px 20px" }}>
                                                <Box display="flex" alignItems="center" gap="10px" justifyContent="flex-end">
                                                    <Link to={`/faculty/assignment/${assignment.assignment_id}`} className='default-link'>
                                                        <Button sx={{ textTransform: "capitalize" }} size="small" color="secondary" variant="outlined">
                                                            Evaluate
                                                        </Button>
                                                    </Link>
                                                    <Box display="flex" alignItems="center">
                                                        <IconButton size="small" onClick={() => editAssignment( assignment )} color="secondary">
                                                            {Icons.default.EditIconOutlined}
                                                        </IconButton>
                                                        <IconButton onClick={() => openDeleteDialog( assignment.assignment_id, assignment.assignment_name )} size="small" color="error">
                                                            {Icons.default.DeleteIconOutlined}
                                                        </IconButton>
                                                    </Box>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    )
                                } )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>}


            </Box>}
            {loaded && AssignmentStore?.getAssignment.filter( assignmentFilterFunc ).length === 0 && <Box padding="20px" display="flex" flexDirection="column" bgcolor={palette.contentBg} marginTop="10px" borderRadius="5px" alignItems="center" justifyContent="center">
                <img src={noASsignmentImg} width="200px" alt="No Assignments!" />
                <Typography marginY="20px" variant='subtitle2' color="textSecondary">No assignments!</Typography>
                {<Box display="flex" gap="10px" alignItems="center">
                    {AssignmentStore?.getAssignment.length > 0 && searchText !== "" && <Button onClick={() => setSearchParamValue( 'searchText', "" )} variant='outlined' sx={{ fontSize: "12px", marginBottom: "20px", textTransform: "capitalize" }} color="error" startIcon={Icons.default.BlockIcon}>Clear filter</Button>}
                    <Button disableElevation startIcon={Icons.default.AddIcon} onClick={() => setView( "create" )} variant='contained'>Create New Assignment</Button>
                </Box>}
            </Box>}
            {/* {loaded && <Box paddingTop="0" display="flex" flexWrap="wrap">
                {AssignmentStore.getAssignment.filter( ( current_assignment ) => {
                    return current_assignment["assignment_name"]?.toLowerCase()?.indexOf( searchText?.toLowerCase() ) > -1
                } ).length > 0 && <Box padding="20px" display="flex" flexWrap="wrap" gap="10px">
                        {
                            AssignmentStore.getAssignment.filter( ( current_assignment ) => {
                                return current_assignment["assignment_name"]?.toLowerCase().indexOf( searchText?.toLowerCase() ) > -1
                            } ).map( ( assignment, k ) => {
                                return (
                                    <Paper elevation={2} sx={{ marginBottom: "10px", minWidth: "200px", width: "250px", "&:hover": { boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" } }} key={assignment["assignment_id"]}>
                                        <Box className="card-body">
                                            <Box onClick={( e ) => handleClickOpen( assignment )} borderRadius="5px 5px 0 0" sx={{ cursor: "pointer" }} color="white" bgcolor={FLAT_COLORS[k % FLAT_COLORS.length]} padding="20px">
                                                <Tooltip title={assignment["assignment_name"]} PopperProps={{ sx: { "& .MuiTooltip-tooltip": { background: "#000", padding: "10px" } } }} placement='top'>
                                                    <Typography variant="h5" noWrap >{assignment["assignment_name"]}</Typography>
                                                </Tooltip>
                                                <Typography variant="body2">Due Date : {assignment["assignment_due_date"].split( "T" )[0]}</Typography>
                                            </Box>
                                            <Box onClick={( e ) => handleClickOpen( assignment )} sx={{ cursor: "pointer" }} marginTop="10px" padding="10px 20px 20px 20px" fontSize="12px" fontWeight="bold">
                                                {assignment["author_name"] + ' '}
                                                <br />
                                                <Typography color="textSecondary" fontSize="12px">Created On: {new Date( assignment["assignment_created_at"] ).toLocaleDateString( "en-IN", { day: "2-digit", month: "2-digit", year: "numeric" } ).replace( /\//g, "-" )}</Typography>
                                            </Box>
                                            <Divider sx={{ background: "rgba(0,0,0,0.15)", height: "2px" }} />
                                            <Box display="flex" flexGrow={1} alignItems="flex-end" justifyContent="flex-start" padding="0 20px 10px 20px" gap="10px" marginTop="10px">
                                                
                                                <Tooltip title="Evaluate">
                                                    <Button variant='contained' color='success' disableElevation size="small" onClick={() => navigate( `/faculty/assignment/${assignment["assignment_id"]}` )}>
                                                        Evaluate
                                                    </Button>
                                                </Tooltip>
                                                <Tooltip title="Edit">
                                                    <IconButton sx={{ color: "secondary.main" }} size="small" onClick={() => editAssignment( assignment )}  >
                                                        {Icons.default.EditIcon}
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Delete">
                                                    <IconButton
                                                        sx={{ color: "error.main" }}
                                                        size="small"
                                                        onClick={() => openDeleteDialog( assignment["assignment_id"], assignment["assignment_name"] )}
                                                    >
                                                        {Icons.default.DeleteIcon}
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                        </Box>
                                    </Paper>
                                )
                            } )
                        }
                    </Box>}

                {
                    loaded && AssignmentStore.getAssignment.filter( ( current_assignment ) => {
                        return current_assignment["assignment_name"]?.toLowerCase().indexOf( searchText?.toLowerCase() ) > -1 || searchText === ""
                    } ).length === 0 &&
                    <Box padding="20px" display="flex" flexDirection="column" bgcolor={palette.contentBg} width="100%" alignItems="center" justifyContent="center">
                        <img src={noASsignmentImg} width="200px" alt="No Assignments!" />
                        <Typography marginY="20px" variant='subtitle2' color="textSecondary">No assignments!</Typography>
                        {searchText !== "" && <Button onClick={() => setSearchParamValue( 'searchText', "" )} variant='outlined' sx={{ fontSize: "12px", marginBottom: "20px", textTransform: "capitalize" }} color="error" startIcon={Icons.default.BlockIcon}>Clear filter</Button>}
                    </Box>
                }
            </Box>} */}
            {
                !loaded && < DataLoadingSpinner padding='20px 0' waitingMessage="Loading assignments..." />
            }
        </Box>
    )
} )

export default AssignmentsList
